import { methods, request } from "./base";

const contentApis = {
  getContent: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/content/stay_informed",
      payload: data,
    }),
  getContentList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/content/content_list",
      payload: data,
    }),
  getTopics: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/content/topic_list",
      payload: data,
    }),
};

export default contentApis;
